// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"ccdcdf14","199":"e350163e","407":"1531ffb3","462":"0dc3932d","722":"332e997b","817":"1a51f526","936":"264468fe"}[chunkId] + ".chunk.js";
};